import * as angular from 'angular';

import { ComponentDefinition } from '@models/index';
import { IApplicationService } from '@services/data';
import { ILoggerService } from '@services/general';

class ModelImportPanelController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    fileList: FileList;
    importResult;

    static $inject = [
        'applicationService',
        'loggerService'
    ];

    constructor(
        private _applicationService: IApplicationService,
        private _loggerService: ILoggerService
    ) {
    }

    uploadExcelFile() {
        if (!!this.fileList && this.fileList.length > 0) {
            this.isLoading = true;
            this.loadingMessage = 'Uploading Excel file';
            this._applicationService.uploadExcel(this.fileList[0])
                .then(data => {
                    this.importResult = Object.keys(data).map(d => (Object.assign({}, data[d], { objectType: d })));
                    this._loggerService.logSuccess('File successfully uploaded!');
                })
                .catch(reason => {
                    this._loggerService.logError(reason.data.message || reason.data.Message);
                })
                .finally(() => {
                    this.fileList = undefined;
                    this.isLoading = false;
                });
        }
    }
}

export const wtModelImportPanel: ComponentDefinition = {
    componentId: 'wtModelImportPanel',
    controller: ModelImportPanelController,
    template: require('./modelImportPanel.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '=?',
        loadingMessage: '=?'
    }
};
